export const FIELD_ORDER = ["date", "payee", "words1", "words2", "amount", "crossing"]

export const FIELD_LABEL = {
  date: "Date (DDMMYYYY)",
  payee: "Payee name",
  words1: "Amount in words · line 1",
  words2: "Amount in words · line 2",
  amount: "Amount in figures",
  crossing: "Crossing",
}

export const REQUIRED_FIELDS = ["date", "payee", "words1", "words2", "amount"]
export const MAX_PRINTABLE_LEAF_WIDTH_MM = 208

export const CROSSING_OPTIONS = [
  { value: "NONE", label: "None" },
  { value: "A/C PAYEE", label: "A/C PAYEE" },
  { value: "NOT NEGOTIABLE", label: "NOT NEGOTIABLE" },
  { value: "A/C PAYEE · NOT NEGOTIABLE", label: "A/C PAYEE · NOT NEGOTIABLE" },
]

export const DEFAULT_LEAF = { widthMm: 202, heightMm: 93, micrBandMm: 15.875 }

// Starting geometry for a brand-new template (mm), signatory/bearer/acNo entries dropped (not built).
export const DEFAULT_FIELDS = {
  date: { key: "date", enabled: true, xMm: 152.5, yMm: 6.5, wMm: 40, hMm: 5.5, fontSizePt: 12, bold: true, align: "CENTER", pitchMm: 5 },
  payee: { key: "payee", enabled: true, xMm: 14, yMm: 18.5, wMm: 147, hMm: 5.5, fontSizePt: 12, bold: true, align: "LEFT" },
  words1: { key: "words1", enabled: true, xMm: 23.5, yMm: 28, wMm: 165.5, hMm: 4.5, fontSizePt: 11, bold: true, align: "LEFT" },
  words2: { key: "words2", enabled: true, xMm: 6, yMm: 37, wMm: 122.5, hMm: 4.5, fontSizePt: 11, bold: true, align: "LEFT" },
  amount: { key: "amount", enabled: true, xMm: 154, yMm: 35.5, wMm: 36.5, hMm: 5, fontSizePt: 13, bold: true, align: "LEFT" },
  crossing: { key: "crossing", enabled: true, xMm: 0, yMm: 9.5, wMm: 27, hMm: 7, fontSizePt: 7.5, bold: true, align: "CENTER", rotationDeg: -55 },
}

export const cloneDefaultFields = () => FIELD_ORDER.map(key => ({ ...DEFAULT_FIELDS[key] }))

export const getTemplateGeometryErrors = (fields, leaf) => {
  const errors = []
  const printableHeightMm = Number(leaf.heightMm) - Number(leaf.micrBandMm || 0)

  if (leaf.widthMm < 150 || leaf.widthMm > MAX_PRINTABLE_LEAF_WIDTH_MM) {
    errors.push(`Leaf width must be between 150 and ${MAX_PRINTABLE_LEAF_WIDTH_MM} mm.`)
  }
  if (leaf.heightMm < 70 || leaf.heightMm > 110) {
    errors.push("Leaf height must be between 70 and 110 mm.")
  }
  if (leaf.micrBandMm < 0 || leaf.micrBandMm > 30 || printableHeightMm <= 0) {
    errors.push("MICR band must be between 0 and 30 mm and smaller than the leaf height.")
  }

  fields.filter(field => field.enabled).forEach(field => {
    if (
      field.xMm < 0 || field.yMm < 0 || field.wMm < 1 || field.hMm < 1
      || field.xMm + field.wMm > leaf.widthMm + 0.01
      || field.yMm + field.hMm > leaf.heightMm + 0.01
    ) {
      errors.push(`${FIELD_LABEL[field.key]} must stay inside the cheque leaf.`)
    } else if (field.yMm + field.hMm > printableHeightMm + 0.01) {
      errors.push(`${FIELD_LABEL[field.key]} must not overlap the MICR band.`)
    }
  })

  return errors
}
